// 设置缓存
export function setItem(key, data) {
    const jsonData = typeof data === 'string' ? data : JSON.stringify(data)
    localStorage.setItem(key, jsonData)
  }
  
  // 获取缓存
  export function getItem(key) {
    const value = localStorage.getItem(key)
    try {
      return JSON.parse(value)
    } catch {
      return value // 不是 JSON 字符串就直接返回
    }
  }
  
  // 删除缓存
  export function removeItem(key) {
    localStorage.removeItem(key)
  }
  
  // 清空所有缓存
  export function clearStorage() {
    localStorage.clear()
  }
  